import { EventEmitter } from 'events';

export default new class extends EventEmitter {
    modals = [];

    activeModal = null;

    open = (name, data = {}, unique = false) => {
        if (unique && this.modals.find(modal => modal.name === name)) {
            return;
        }

        this.modals.push({ name, data });
        this.emit('open');
    };

    setActiveModal = (modal) => this.activeModal = modal;

    getActiveModal = () => this.activeModal;

    closeActiveModal = () => this.activeModal = null;

    isModalOpen = () => this.modals.length > 0;
};
